import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';

import { getRelevancyScoreColorLifecycle } from '../../CandidateProgressTable';

type OrgChartTooltipProps = {
  name: string;
  profilePhoto: string;
  mentees: number;
  mentorMatch: string;
};

export const OrgChartTooltip = ({ name, profilePhoto, mentees, mentorMatch }: OrgChartTooltipProps) => (
  <Box
    w="244px"
    display="flex"
    flexDirection="column"
    p="8px"
    bg="white"
    gap="8px"
    borderRadius="8px"
    boxShadow="0px 2px 8px 0px #00000014"
  >
    <Flex alignItems="center" justifyContent="start" pl="12px">
      <Heading as="h1" fontWeight="590" fontSize="12px" lineHeight="16px" color="#333">
        Ideal Mentor
      </Heading>
    </Flex>
    <Flex direction="column" gap="8px" p="8px">
      <Flex direction="column" gap="4px">
        <Heading as="h2" color="gray.500" fontWeight="400" fontSize="10px" lineHeight="16px">
          Mentor match score
        </Heading>
        <Text color={getRelevancyScoreColorLifecycle(mentorMatch)} fontWeight="bold" fontSize="14px" lineHeight="20px">
          {mentorMatch}
        </Text>
      </Flex>
      <Flex direction="column" gap="4px">
        <Heading as="h2" color="gray.500" fontWeight="400" fontSize="10px" lineHeight="16px">
          Suggested for employee
        </Heading>
        <Flex gap="8px">
          <Image
            src="https://media.mesh.ai/2415/media/profilePhoto/50723/2023/01/06/50723.jpg_1673027618924"
            alt="avatar"
            w="20px"
            h="20px"
            borderRadius="50%"
            objectFit="cover"
          />
          <Text color="gray.700" fontWeight="400" fontSize="14px" lineHeight="20px">
            Alex Spencer
          </Text>
        </Flex>
      </Flex>
      <Flex direction="column" gap="4px">
        <Heading as="h2" color="gray.500" fontWeight="400" fontSize="10px" lineHeight="16px">
          No. of mentees
        </Heading>
        <Text color="black" fontWeight="bold" fontSize="14px" lineHeight="20px">
          {mentees}
        </Text>
      </Flex>
    </Flex>
    <Box h="1px" bg="#EBEFF3" />
    <Flex gap="8px">
      <Image src={profilePhoto} alt="avatar" w="20px" h="20px" borderRadius="50%" objectFit="cover" />
      <Text color="gray.700" fontWeight="400" fontSize="14px" lineHeight="20px">
        {name}
      </Text>
    </Flex>
  </Box>
);
